<ng-container *ngIf="metroStationOptions$ | async as options">
  <nz-select *ngIf="options.length"
    class="select-centers full-width nowrap mb-20 max-w-448"
    nzPlaceHolder="Все станции метро"
    [nzAllowClear]="true"
    [nzOptions]="options"
    [ngModel]="selectedMetro$ | async"
    (ngModelChange)="selectMetro($event)"
  >
  </nz-select>
</ng-container>

<ya-map
  (click)="onNavigate($event.target)"
  class="block min-h-208 max-h-768 relative"
  style="height: 60vh; z-index: 0"
  [state]="stateMap"
  [options]="optionsMap"
  (ready)="onMapReady($event)"
  (sizechange)="resetMap($event)"
>
  <ya-clusterer [options]="clustererOptions">
    <ya-placemark
      *ngFor="let placemark of placemarksCenters$ | async"
      [geometry]="placemark.geometry"
      [options]="placemark.options"
      [properties]="placemark.properties"
      (yaclick)="selectCenter(placemark)"
    ></ya-placemark>
  </ya-clusterer>
</ya-map>

<app-shared-balloon-mobile
  *ngIf="isOpenBalloonMobile && promotionMapService.isMobile"
  (closeBalloon)="closeBalloonMobile()"
>
  <ng-container *ngIf="selectedPlacemark">
    <ng-container
      *ngIf="selectedPlacemark.centerInfo as center"
    >
      <div
        class="typography typography-bold grey-800"
        style="margin-bottom: 12px"
      >
        Вы выбрали Диагностический центр:
      </div>

      <div class="grid grid-nowrap align-items-start">
        <img [src]="markplace" [alt]="markplace" />

        <div class="ml-24">
          <div class="typography typography-headline">
            {{ center.name }}
          </div>

          <div class="typography grey-800 mt-8 mb-16">
            {{ center.address }}
          </div>

          <a
            class="typography green-basic typography-underline"
            [routerLink]="'/center/' + center.code"
            >Подробная информация</a
          >
        </div>
      </div>
    </ng-container>
  </ng-container>
</app-shared-balloon-mobile>
